import { SIGNUP_URL } from "@/constants/links";

export default function Hero({ onOpenDemo }) {
    return (
        <section className="hero" id="top" data-testid="v2-hero">
            <div className="container hero__inner">
                <span className="hero__eyebrow reveal" data-testid="v2-hero-eyebrow">
                    <span className="hero__eyebrow-dash" aria-hidden="true" />
                    The management layer of a growing business
                </span>

                <h1 className="hero__headline reveal" data-testid="v2-hero-headline">
                    Every company is <em>managed</em>.
                    <br />
                    The question is whether it&rsquo;s managed on purpose.
                </h1>

                <p className="hero__sub reveal" data-testid="v2-hero-sub">
                    <strong>C-ORE is the management layer</strong> that sits above your
                    books, your team and your tools &mdash; watching the numbers,
                    writing the brief and holding the plan. C&#8209;ORE CEO, CFO, CMO
                    and CTO &mdash; one system, four lenses.
                </p>

                <div className="hero__actions reveal" data-testid="v2-hero-actions">
                    <a
                        className="btn btn--primary btn--lg"
                        href={SIGNUP_URL}
                        data-testid="v2-hero-cta-trial"
                    >
                        Start 15-day trial
                    </a>
                    <button
                        type="button"
                        className="btn btn--secondary btn--lg"
                        onClick={onOpenDemo}
                        data-testid="v2-hero-cta-demo"
                    >
                        See a demo
                    </button>
                </div>

                <div className="hero__note reveal" data-testid="v2-hero-note">
                    <span className="hero__note-dot" aria-hidden="true" />
                    15 days free &middot; No credit card &middot; Setup in 60 minutes
                </div>

                <div
                    className="hero__stage reveal"
                    data-testid="v2-hero-stage"
                    aria-hidden="true"
                >
                    <div className="hero__stage-glow" />

                    <div className="hero__composite" data-testid="v2-hero-composite">
                        <img
                            src="/img/v2/hero-composite.png?v=3"
                            alt="C-ORE Boardroom on laptop and Command Center on phone"
                            loading="eager"
                            width="1571"
                            height="959"
                        />
                    </div>

                    <div className="hero__chip hero__chip--tl">
                        <span
                            className="hero__chip-dot hero__chip-dot--cyan"
                            aria-hidden="true"
                        />
                        <span>
                            Tally &middot;{" "}
                            <span className="hero__chip-muted">2h ago</span>
                        </span>
                    </div>

                    <div className="hero__chip hero__chip--tr">
                        <span className="hero__chip-dot" aria-hidden="true" />
                        <span>
                            <span className="hero__chip-muted">Runway</span>
                            &nbsp;&nbsp;
                            <span className="hero__chip-strong">5.8 months</span>
                        </span>
                    </div>

                    <div className="hero__chip hero__chip--ml">
                        <span className="hero__chip-dot" aria-hidden="true" />
                        <span>
                            <span className="hero__chip-muted">Vision</span>
                            &nbsp;&nbsp;
                            <span className="hero__chip-strong">
                                &#8377;120 Cr / 3 yrs
                            </span>
                        </span>
                    </div>

                    <div className="hero__chip hero__chip--br">
                        <span className="hero__chip-dot" aria-hidden="true" />
                        <span>
                            C&#8209;ORE&nbsp;CFO &middot;{" "}
                            <span className="hero__chip-muted">
                                Boardroom brief
                            </span>
                        </span>
                    </div>
                </div>

                <div className="hero__trust reveal" data-testid="v2-hero-trust">
                    <div className="hero__trust-item">
                        <span className="hero__trust-label">Reads from</span>
                        <span className="hero__trust-value">
                            Tally · Zoho · GST · Excel
                        </span>
                    </div>
                    <div className="hero__trust-item">
                        <span className="hero__trust-label">Delivered on</span>
                        <span className="hero__trust-value">
                            Dashboard · WhatsApp
                        </span>
                    </div>
                    <div className="hero__trust-item">
                        <span className="hero__trust-label">Trial</span>
                        <span className="hero__trust-value">
                            15 days · No card
                        </span>
                    </div>
                    <div className="hero__trust-item">
                        <span className="hero__trust-label">Setup</span>
                        <span className="hero__trust-value">Under 60 minutes</span>
                    </div>
                </div>
            </div>
        </section>
    );
}
